import React, {Suspense} from 'react';
import PageLayout from "@view/layout/pageLayout/PageLayout";
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import {SmsAdminLazy} from "@containers/smsAdmin/SmsAdmin.lazy";


export const SmsAdminPage = () => {
	return (
		<PageLayout>
			<Suspense
				fallback={<SpinnerCustom/>}
			>
				<SmsAdminLazy/>
			</Suspense>
		</PageLayout>
	)
};
